<template>
  <div class="moments">
    <DefTitle :result="1" :center="true">
      <h2>{{ messages.title }}</h2>
    </DefTitle>
    <p class="moments__text">{{ messages.preview }}</p>
    <div ref="items" class="moments-items">
      <MomentsItem
        v-for="(item, i) in result.items"
        :key="item.id"
        :result="item"
        :active="activeNumber === i"
        :img-width="imgWidth"
        :img-height="imgHeight"
        @changeSlide="handlerChangeSlide(i)"
      />
    </div>
    <SliderAllButton :href="messages.allSets.link">
      {{ messages.allSets.title }}
    </SliderAllButton>
  </div>
</template>

<script lang="ts" setup>
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import { IMomentsResult } from '@components/Moments/IMoments';
import MomentsItem from '@components/Moments/MomentsItem.vue';
import { ref, onMounted, watch, computed, onBeforeUnmount } from 'vue';
import { screenWidth } from '@use/useDeviceInfo';
import SliderAllButton from '@components/sliders/SliderAllButton.vue';

const props = defineProps<{ result: IMomentsResult }>();

const activeNumber = ref(0);
const items = ref<HTMLDivElement | null>(null);
const imgWidth = ref('0px');
const imgHeight = ref('0px');

const messages = computed(() => props.result.messages);
let intervalId: null | number = null;

// const tabColors = ['#000', '#618EAF', '#FF9CB3', '#B3D5EF'];

/** all need for images size * */
const setImgSize = () => {
  const activeElement = items?.value?.querySelector('.moments-item_active');
  if (activeElement) {
    const imgWrapper: HTMLLinkElement | null = activeElement.querySelector('.moments-item-main');

    if (imgWrapper) {
      imgWidth.value = `${imgWrapper.offsetWidth}px`;
      imgHeight.value = `${imgWrapper.offsetHeight}px`;
    }
  }
};

watch(screenWidth, (newVal) => {
  setImgSize();
});

const handlerChangeSlide = (i: number) => {
  activeNumber.value = i;
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

onMounted(() => {
  setImgSize();

  intervalId = window.setInterval(() => {
    if (props.result.items.length - 1 === activeNumber.value) {
      activeNumber.value = 0;
    } else {
      activeNumber.value += 1;
    }
  }, 7000);
});
onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
});
</script>

<style lang="scss" scoped>
.moments {
  margin-bottom: 56px;
  @include point-md {
    margin-bottom: 80px;
  }
  @include point-lg {
    margin-bottom: 100px;
  }
  :deep(.def-title) {
    margin-bottom: 8px;
    @include point-lg {
      margin-bottom: 16px;
    }
  }
  &__text {
    color: #363636;
    font-size: 16px;
    font-weight: 500;
    line-height: 120%;
    margin-bottom: 16px;
    text-align: center;
    @include point-md {
      margin-bottom: 24px;
    }
    @include point-lg {
      margin-bottom: 32px;
      font-size: 20px;
    }
  }
}
.moments-items {
  @include point-md {
    display: flex;
  }
}
</style>
